export const isTouchDevice = "ontouchstart" in document.documentElement;

export const generateQueryString = (data = {}) => {
  let params = data;

  if (data instanceof FormData === true) {
    params = {};

    data.forEach((value, key) => (params[key] = value));
  }

  for (const key in params) {
    if (params[key] === "") {
      delete params[key];
    }
  }

  return new URLSearchParams(params);
};

export const updateQueryParams = (params = []) => {
  const url = new URL(window.location.href);

  if (params === false) {
    url.search = "";

    return url;
  }

  const updatedParams = new URLSearchParams(url.search);

  params.forEach((param) => {
    const key = param[0];
    const value = param[1] ?? false;

    if (value) {
      updatedParams.set(key, value);
    } else {
      updatedParams.delete(key);
    }
  });

  url.search = updatedParams.toString();

  return url;
};

export const trackGoogleAnalytics = (event) => {
  if (window.dataLayer) {
    window.dataLayer.push(event);
  }
};

/**
 * Fires a custom event with the given name on the specified target element(s),
 * and passes optional detail data.
 *
 * @param {string} eventName - The name of the custom event to fire.
 * @param {EventTarget | Iterable<EventTarget>} target - The target element or a collection of elements to dispatch the event on.
 * @param {Object} [detail={}] - Optional data to pass with the event (default is an empty object).
 */
export const fireEvent = (eventName, target, detail = {}) => {
  // Create the custom event with the specified name and detail
  const event = new CustomEvent(eventName, {
    detail: detail,
    bubbles: true,
    cancelable: true,
  });

  // Check if the target is iterable (e.g., NodeList, Array)
  if (target && typeof target[Symbol.iterator] === "function") {
    for (const element of target) {
      // Ensure the current item is a valid EventTarget
      if (element && typeof element.dispatchEvent === "function") {
        element.dispatchEvent(event);
      } else {
        console.warn(`fireEvent: One of the targets is not a valid EventTarget.`);
      }
    }
  }
  // If the target is a single EventTarget
  else if (target && typeof target.dispatchEvent === "function") {
    target.dispatchEvent(event);
  }
  // If the target is neither a single EventTarget nor iterable
  else {
    console.warn(
      `fireEvent: target must be an EventTarget or an iterable of EventTargets. Received type '${typeof target}'.`,
    );
  }
};
